
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class CustomerRequirementStoneItemsGrid extends Serenity.EntityGrid<CustomerRequirementStoneItemsRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.CustomerRequirementStoneItems'; }
        protected getDialogType() { return CustomerRequirementStoneItemsDialog; }
        protected getIdProperty() { return CustomerRequirementStoneItemsRow.idProperty; }
        protected getInsertPermission() { return CustomerRequirementStoneItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return CustomerRequirementStoneItemsRow.localTextPrefix; }
        protected getService() { return CustomerRequirementStoneItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

        }

    }
}